//@ts-ignore
import CollectionWithHelpers from 'app/scripts/models/collections/internal/collection-with-helpers';
import { PendingOrganization } from 'app/scripts/models/PendingOrganization';

//@ts-ignore
class PendingOrganizationList extends CollectionWithHelpers {
  static initClass() {
    this.prototype.model = PendingOrganization;
  }
}
PendingOrganizationList.initClass();

export { PendingOrganizationList };
